import { render, staticRenderFns } from "./ProductViewWarehousesProducts.vue?vue&type=template&id=7c38ee0d"
import script from "./ProductViewWarehousesProducts.vue?vue&type=script&lang=js"
export * from "./ProductViewWarehousesProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports